import { useAtom } from 'jotai/index'

import { RoomTableColType, roomTableSortStore } from 'src/stores/roomTableSortStore'

export const useRoomTableSort = () => {
  const [storeValue, setStoreValue] = useAtom(roomTableSortStore.state)

  const updateSortItem = (
    input:
      | { col: RoomTableColType; type: 'asc' | 'desc' }
      | { col: 'selectMaster'; selectMasterId: string; type: 'asc' | 'desc' }
  ) => {
    setStoreValue(previous => ({
      ...previous,
      sortItem: input,
    }))
  }

  const resetSortItem = () => {
    setStoreValue(previous => ({
      ...previous,
      sortItem: undefined,
    }))
  }

  return {
    sortItem: storeValue.sortItem,
    updateSortItem,
    resetSortItem,
  }
}
